import { UnitedStatesState } from '@shared';

// Representative zip code (state capital) for each US state, used by the
// admin-only state autofill dropdowns.
export const STATE_ZIP_CODES: Record<string, string> = {
  AL: '36104', // Montgomery
  AK: '99801', // Juneau
  AZ: '85004', // Phoenix
  AR: '72201', // Little Rock
  CA: '95814', // Sacramento
  CO: '80202', // Denver
  CT: '06103', // Hartford
  DE: '19901', // Dover
  DC: '20001', // Washington
  FL: '32301', // Tallahassee
  GA: '30303', // Atlanta
  HI: '96813', // Honolulu
  ID: '83702', // Boise
  IL: '62701', // Springfield
  IN: '46204', // Indianapolis
  IA: '50309', // Des Moines
  KS: '66603', // Topeka
  KY: '40601', // Frankfort
  LA: '70802', // Baton Rouge
  ME: '04330', // Augusta
  MD: '21401', // Annapolis
  MA: '02108', // Boston
  MI: '48933', // Lansing
  MN: '55102', // St. Paul
  MS: '39201', // Jackson
  MO: '65101', // Jefferson City
  MT: '59601', // Helena
  NE: '68502', // Lincoln
  NV: '89701', // Carson City
  NH: '03301', // Concord
  NJ: '08608', // Trenton
  NM: '87501', // Santa Fe
  NY: '12207', // Albany
  NC: '27601', // Raleigh
  ND: '58501', // Bismarck
  OH: '43215', // Columbus
  OK: '73102', // Oklahoma City
  OR: '97301', // Salem
  PA: '17101', // Harrisburg
  RI: '02903', // Providence
  SC: '29201', // Columbia
  SD: '57501', // Pierre
  TN: '37219', // Nashville
  TX: '78701', // Austin
  UT: '84111', // Salt Lake City
  VT: '05602', // Montpelier
  VA: '23219', // Richmond
  WA: '98501', // Olympia
  WV: '25301', // Charleston
  WI: '53703', // Madison
  WY: '82001', // Cheyenne
};

export const STATE_AUTOFILL_OPTIONS = Object.keys(STATE_ZIP_CODES)
  .map(abbr => ({ abbr, name: UnitedStatesState[abbr]?.stateName ?? abbr }))
  .sort((a, b) => a.name.localeCompare(b.name));
